import { Directive, EventEmitter, Inject, Input, Optional, Output, ViewChild } from '@angular/core';
import { NG_ASYNC_VALIDATORS, NG_VALIDATORS, NgModel } from '@angular/forms';
import { FndBaseValidatingFormElementComponent } from 'findomestic-ui-components';

@Directive()
export abstract class FndBaseFormElementComponent extends FndBaseValidatingFormElementComponent<any> {

  @Input() id: string = "";
  @Input() label: string = null;
  // ANGULAR 12: removed (typescript override error), already defined in FndBaseValidatingFormElementComponent
  // @Input() value: any = null;
  @Input() hint: string = null;
  @Input() error = false;
  @Input() model: any = null;
  @Input() readOnly = false;
  @Input() disabled = false;
  @Input() customCssClass: string = null;
  @Input() errorMessage: string = null;

  @Input("name")
  get name(): string {
    return this.id;
  }
  set name(name: string) {
    this.id = name;
  }

  @Output() valueChange: EventEmitter<Object> = new EventEmitter<Object>();
  @Output() valueBlur:EventEmitter<Object>=new EventEmitter<Object>();
  @Output() valueFocus:EventEmitter<Object>=new EventEmitter<Object>();

  @ViewChild(NgModel, {static: true}) ngModelElement: NgModel;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
  ) {
    super(validators, asyncValidators);
  }

  onChange(value: string) {
    this.valueChange.emit({id:this.id, value:value});
  }

  onBlur(value: string) {
    this.valueBlur.emit({id:this.id});
  }

  onFocus() {
    this.valueFocus.emit({id:this.id});
  }

}